import(/* webpackMode: "eager" */ "/codebuild/output/src4093322249/src/apps/profile/src/app/error.tsx");
